import './QuantitativeIndicatorFields.css';

import React, { useState } from 'react';
import { generateClassName, generateSelectField } from '../../../b2b-common/helpers';
import useMeasurementUnits from '../../hooks/useMeasurementUnits';
import { Info } from '@mui/icons-material';

export const MeasurementUnitSelector = ({ indicator, setIndicator, className = null }) => {
    const measurementUnits = useMeasurementUnits();
    const [isInfoHovered, setIsInfoHovered] = useState(false);
    const isUsed = indicator && indicator.areaIndicatorDTOs && indicator.areaIndicatorDTOs.length > 0;

    if (!measurementUnits) {
        return null;
    }

    const measurementUnitsList = measurementUnits.map((unit) => {
        return {
            value: unit.quantitativeMeasurementUnitId,
            label: unit.quantitativeMeasurementUnitName
        };
    });

    const handleChangeMeasurementUnit = (event) => {
        const measurementUnitId = event.target.value;
        const measurementUnit = measurementUnits.find((unit) => unit.quantitativeMeasurementUnitId === measurementUnitId);
        setIndicator({ ...indicator, quantitativeMeasurementUnitDTO: measurementUnit });
    }

    return (
        <div className={generateClassName('quantitative-indicator-measurement-unit-selector', '', className)}>
            {
                generateSelectField(measurementUnitsList,
                    {
                        label: 'Measurement Unit',
                        value: indicator.quantitativeMeasurementUnitDTO?.quantitativeMeasurementUnitId,
                        onChange: handleChangeMeasurementUnit,
                        className: 'quantitative-indicator-measurement-unit',
                        disabled: isUsed
                    }
                )
            }
            <div
                onMouseOver={() => setIsInfoHovered(true)}
                onMouseOut={() => setIsInfoHovered(false)}
                className='quantitative-indicator-measurement-unit-info'
            >
                <Info />
            </div>
            {isInfoHovered && (
                <div className='quantitative-indicator-measurement-unit-info-tooltip'>
                    {indicator.quantitativeMeasurementUnitDTO?.quantitativeMeasurementUnitDescription}
                </div>
            )}
        </div>
    );
}

const QuantitativeIndicatorFields = ({ indicator, setIndicator, className = null }) => {
    return (
        <MeasurementUnitSelector indicator={indicator} setIndicator={setIndicator} className={className} />
    );
}

export default QuantitativeIndicatorFields;